module.exports = __webpack_public_path__ + "img/User_input.496d3335.gif";